import React from 'react'
import { Redirect, Route, RouteProps } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getUserSelector } from '../../features/user/selectors'
import { AuthenticationService } from '../../features/login/services/authentication.service'
import { AppRouterConstants } from './AppRouter.constants'
import ErrorBoundaryWrapper from '../errorBoundry/ErrorBoundry.component'

interface ProtectedAuthenticatedRouteProps extends Omit<RouteProps, 'render'> {
  component: React.ComponentType<any>
}

const ProtectedAuthenticatedRoute: React.FC<ProtectedAuthenticatedRouteProps> = ({ component: Component, ...rest }) => {
  const user = useSelector(getUserSelector)
  const allowSecureRoutes = AuthenticationService.allowSecureRoutes(user)

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!allowSecureRoutes) return <Redirect to={AppRouterConstants.INDEX_ROUTE} />
        return (
          <ErrorBoundaryWrapper>
            <Component {...props} />
          </ErrorBoundaryWrapper>
        )
      }}
    />
  )
}

export default ProtectedAuthenticatedRoute
